"use client";
import cn from "@/utils/cn";

const BillingToggle = ({
  isMonthly,
  setIsMonthly,
  className = "",
}: {
  isMonthly: boolean;
  setIsMonthly: (value: boolean) => void;
  className?: string;
}) => {
  return (
    <div className={cn("flex items-center justify-center", className)}>
      <label
        className="flex cursor-pointer items-center space-x-2 text-[9px] leading-[28px] xl:text-[12px]"
        onClick={() => setIsMonthly(!isMonthly)}
      >
        <span
          className={cn(
            isMonthly ? "text-[#444A6D] font-medium" : "text-[#96A5B8]",
          )}
        >
          Monthly
        </span>

        <div className="relative flex h-[11.25px] w-[21px] items-center rounded-[4px] border border-kd-lte-blue xl:h-[15px] xl:w-[28px] xl:rounded-[6px]">
          <div
            className={cn(
              "absolute bg-kd-lte-blue xl:size-[10px] size-[7.5px] rounded-[3px] xl:rounded-[4px]",
              isMonthly ? "left-[3px]" : "right-[3px]",
            )}
          />
        </div>
        <span
          className={cn(
            !isMonthly ? "text-[#444A6D] font-medium" : "text-[#96A5B8]",
          )}
        >
          Annually
        </span>
      </label>
    </div>
  );
};

export default BillingToggle;
